import { PxdAgGridColumnTypes, PxdAgGridDefaultColumnDef, PxdAgGridEvents, PxdAgGridExcelStyles, PxdAgGridOptions, PxdAgGridSideBarOptions, PxdAgGridStatusBarOptions, PXDDefaultExcelExportParams } from '@app/shared/aggrid/pxd-ag-grid-options';
import { BehaviorSubject, Subject } from 'rxjs';

export interface ForecastScenario {
  CapitalForecastLogId?: number;
  ScenarioId: number;
  Comments: string | null;
}

export const forecastScenariosGridOptions: PxdAgGridOptions = {
  enableCharts: true,
  cellSelection: true,
  rowGroupPanelShow: 'never',
  defaultColDef: PxdAgGridDefaultColumnDef,
  statusBar: PxdAgGridStatusBarOptions,
  sideBar: PxdAgGridSideBarOptions,
  columnTypes: PxdAgGridColumnTypes,
  excelStyles: PxdAgGridExcelStyles,
  defaultExcelExportParams: PXDDefaultExcelExportParams,
  rowSelection: { mode: 'singleRow', checkboxes: false, enableClickSelection: true },
  editType: 'fullRow',
  onSelectionChanged: onSelectionChanged,
  onCellDoubleClicked: onCellDoubleClicked,
  masterDetail: true,
  detailCellRendererParams: {
    detailGridOptions: {
      defaultColDef: PxdAgGridDefaultColumnDef,
      statusBar: PxdAgGridStatusBarOptions,
      sideBar: PxdAgGridSideBarOptions,
      columnTypes: PxdAgGridColumnTypes,
      excelStyles: PxdAgGridExcelStyles,
      defaultExcelExportParams: PXDDefaultExcelExportParams,
      rowSelection: { mode: 'singleRow', checkboxes: false, enableClickSelection: true },
      editType: 'fullRow',
      onSelectionChanged: onSelectionChanged,
      onCellDoubleClicked: onCellDoubleClicked,
      columnDefs: [
        { field: 'CapitalForecastLogId', editable: false },
        { field: 'LastForecastRunDate', type: ['dateColumn'], cellClass: 'ExcelDate', headerName: 'Forecast Run Date', editable: false },
        { field: 'ParentBuildId', headerName: 'Forecast Run Id', editable: false, hide: true },
        { field: 'Comments', editable: (params) => params.data.CapitalForecastLogId > 0 }
      ],
      onFirstDataRendered: (params) => {
        params.api.addEventListener('cellValueChanged', (event) => {
          detailForecastRequest.next(event);
        });
      },
    },
    getDetailRowData: (params) => {
      detailForecastRequest.next(params);
    }
  },
  columnDefs: [
    { field: 'ScenarioId', editable: false, cellRenderer: "agGroupCellRenderer" },
    { field: 'ScenarioName', editable: false },
    { field: 'ScenarioType', editable: false },
    { field: 'IsLive', headerName: 'Is Live?', editable: false },
    { field: 'CreatedDate', type: ['dateColumn'], cellClass: 'ExcelDate', headerName: 'Scenario Creation Date', editable: false },
    { field: 'CreatedBy', editable: false },
    { field: 'LastForecastRunDate', type: ['dateColumn'], cellClass: 'ExcelDate', headerName: 'Forecast Run Date', editable: false },
    { field: 'CapitalForecastLogId', editable: false },
    { field: 'ParentBuildId', headerName: 'Forecast Run Id', editable: false, hide: true },
    { field: 'Comments', editable: (params) => params.data.CapitalForecastLogId > 0 }
  ],
  isRowMaster: () => true
};

export const forecastScenariosGridEvents: PxdAgGridEvents = {
  selectionChanged: new Subject<any>(),
  cellDoubleClicked: new Subject<any>()
};

export const detailForecastRequest = new BehaviorSubject<any>(null);

function onSelectionChanged(event) {
  let selectedRows = event.api.getSelectedRows();
  let selectedIds = selectedRows.map(m => { return { scenarioId: m.ScenarioId, capitalForecastLogId: m.CapitalForecastLogId, isReadOnly: m.IsReadOnly, parentBuildId: m.ParentBuildId }; });
  forecastScenariosGridEvents.selectionChanged.next(selectedIds[0]);
}

function onCellDoubleClicked(event) {
  if (event.column.colId === 'Comments' && event.data.CapitalForecastLogId > 0) {
    return;
  }

  let selectedRows = event.api.getSelectedRows();
  let selectedIds = selectedRows.map(m => { return { scenarioId: m.ScenarioId, capitalForecastLogId: m.CapitalForecastLogId, isReadOnly: m.IsReadOnly, parentBuildId: m.ParentBuildId }; });

  forecastScenariosGridEvents.cellDoubleClicked.next(selectedIds[0]);
}